import * as React from 'react';

import { getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { ERoomsTotal } from '../../../../../api-models/common/json_query';
import { FlatRooms } from '../../../components/advancedFilters/FlatRooms';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const FlatRoomsContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const rooms = getTermsValue('rooms_count')(jsonQuery);

  const handleChange = React.useCallback(
    (value: NonEmptyArray<ERoomsTotal> | null) => {
      onChange({ action: 'setRoomsCount', arguments: [value] });
    },
    [onChange],
  );

  return <FlatRooms value={rooms as NonEmptyArray<ERoomsTotal> | null} onChange={handleChange} />;
};
